import { Merchant, ModuleStatus } from '../types/merchant.types';

/**
 * The Orders & Transfers module switch (docs/plans/orders-and-transfers.md
 * §4.2). Pure rules shared by service-merchants (which enforces them) and
 * the admin app (which offers only the allowed moves).
 */

/** A merchant without the field has the module DISABLED. */
export const ordersTransfersStatusOf = (
  merchant: Pick<Merchant, 'modules'> | null | undefined,
): ModuleStatus =>
  merchant?.modules?.orders_transfers?.status ?? ModuleStatus.DISABLED;

/**
 * Allowed moves. DISABLED is reached only from SUSPENDED (wind down first),
 * and only once nothing is open (drain-status, checked by the service);
 * from DISABLED the module can only be turned back on.
 */
export const MODULE_STATUS_TRANSITIONS: Record<ModuleStatus, ModuleStatus[]> = {
  [ModuleStatus.DISABLED]: [ModuleStatus.ENABLED],
  [ModuleStatus.ENABLED]: [ModuleStatus.SUSPENDED, ModuleStatus.FROZEN],
  [ModuleStatus.SUSPENDED]: [
    ModuleStatus.ENABLED,
    ModuleStatus.FROZEN,
    ModuleStatus.DISABLED,
  ],
  [ModuleStatus.FROZEN]: [ModuleStatus.ENABLED, ModuleStatus.SUSPENDED],
};

export const canTransitionModuleStatus = (
  from: ModuleStatus,
  to: ModuleStatus,
): boolean => MODULE_STATUS_TRANSITIONS[from]?.includes(to) ?? false;
